/*!
 *
 *  menu.js
 *
 */

var $global = $('#Global');
var $globalLink = $global.find('a');
var globalMenu = function(){
	$global.on('mouseenter', function(){
		$global.addClass('st-Global-hover');
	}).on('mouseleave', function(){
		$global.removeClass('st-Global-hover');
		setTimeout(function(){
			for( var i=0; i<5; i++ ){
				$global.removeClass('st-Global-' + i);
			};
		}, 400);
	});

	$globalLink.on('mouseenter', function(){
		var index = $(this).parent().index();
		for( var i=0; i<5; i++ ){
			if( i === index ){
				$global.addClass('st-Global-' + i);
			}else{
				$global.removeClass('st-Global-' + i);
			};
		};
	});
};


var $menu = $('#Menu');
var $menuBtn = $('#MenuBtn');
var hamMenu = function(){
	$menuBtn.on('tap', function(e){
		e.preventDefault();
		$(this).toggleClass('st-Header_Menu_Btn-expanded');
		$menu.toggleClass('st-Menu-expanded');
	});
};


module.exports = function(){
	globalMenu();
	hamMenu();
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/menu.js
// module id = 20
// module chunks = 0